import {
  Box, Container, Flex, Skeleton, SkeletonText, VStack, HStack,
} from "@chakra-ui/react";
import { SIDEBAR_WIDTH } from "definitions/constants/styling";

export default function AppPageSkeleton() {
  return (
    <Box minH="100vh" maxW="100vw" position="relative">
      <Flex height="100vh" id="app-container">
        {/* Sidebar skeleton */}
        <Box
          w={`var(--chakra-sizes-${SIDEBAR_WIDTH})`}
          bg="gray.900"
          color="white"
          fontSize="sm"
          height="100vh"
          overflowY="scroll"
          p="4"
        >
          <VStack spacing="4" align="stretch">
            {/* Logo area */}
            <Skeleton height="10" borderRadius="md" />

            {/* Navigation items */}
            {Array.from({ length: 8 }).map((_, i) => (
              <HStack key={i} spacing="3">
                <Skeleton height="4" width="4" borderRadius="sm" />
                <Skeleton height="4" flex="1" borderRadius="sm" />
              </HStack>
            ))}

            {/* Bottom section */}
            <Box mt="auto" pt="4">
              <HStack spacing="3">
                <Skeleton height="6" width="6" borderRadius="full" />
                <VStack align="start" spacing="1" flex="1">
                  <Skeleton height="3" width="20" borderRadius="sm" />
                  <Skeleton height="2" width="16" borderRadius="sm" />
                </VStack>
              </HStack>
            </Box>
          </VStack>
        </Box>

        {/* Main content area */}
        <Container
          height="100vh"
          overflowY="scroll"
          maxWidth={`calc(100% - var(--chakra-sizes-${SIDEBAR_WIDTH}))`}
          bg="gray.50"
          flex="1"
          display="flex"
          flexDirection="column"
          px="0"
        >
          {/* Navbar skeleton */}
          <Box px="6" py="4" borderBottom="1px" borderColor="gray.200">
            <HStack justify="space-between">
              <Skeleton height="6" width="48" borderRadius="md" />
              <HStack spacing="4">
                <Skeleton height="8" width="8" borderRadius="full" />
                <Skeleton height="6" width="24" borderRadius="md" />
              </HStack>
            </HStack>
          </Box>

          {/* Main content blocks */}
          <Box px="6" py="6" flex="1">
            <VStack spacing="6" align="stretch">
              {/* Header section */}
              <Box>
                <Skeleton height="8" width="64" mb="2" borderRadius="md" />
                <Skeleton height="4" width="96" borderRadius="sm" />
              </Box>

              {/* Content blocks */}
              <HStack spacing="6" align="start">
                {/* Left column */}
                <VStack spacing="4" flex="2" align="stretch">
                  <Box p="6" bg="white" borderRadius="lg" border="1px" borderColor="gray.200">
                    <Skeleton height="5" width="32" mb="4" borderRadius="md" />
                    <SkeletonText noOfLines={4} spacing="3" />
                  </Box>

                  <Box p="6" bg="white" borderRadius="lg" border="1px" borderColor="gray.200">
                    <Skeleton height="5" width="40" mb="4" borderRadius="md" />
                    <VStack spacing="3" align="stretch">
                      {Array.from({ length: 3 }).map((_, i) => (
                        <HStack key={i} spacing="4">
                          <Skeleton height="10" width="10" borderRadius="md" />
                          <VStack align="start" spacing="1" flex="1">
                            <Skeleton height="4" width="75%" borderRadius="sm" />
                            <Skeleton height="3" width="50%" borderRadius="sm" />
                          </VStack>
                        </HStack>
                      ))}
                    </VStack>
                  </Box>
                </VStack>

                {/* Right column */}
                <VStack spacing="4" flex="1" align="stretch">
                  <Box p="6" bg="white" borderRadius="lg" border="1px" borderColor="gray.200">
                    <Skeleton height="5" width="24" mb="4" borderRadius="md" />
                    <VStack spacing="3" align="stretch">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <HStack key={i} spacing="3">
                          <Skeleton height="2" width="2" borderRadius="full" />
                          <Skeleton height="3" flex="1" borderRadius="sm" />
                        </HStack>
                      ))}
                    </VStack>
                  </Box>
                </VStack>
              </HStack>
            </VStack>
          </Box>
        </Container>
      </Flex>
    </Box>
  );
}
